import { useFeatureFlag } from "./useLaunchDarkly";
import { getUserClaims } from "../utils/auth";
import { isV2User } from "../utils/rbac";

/**
 * Whether Create should open the method chooser modal (quick start / manual /
 * AI-assisted) rather than deep-linking straight to the admin AI-scoring tool.
 *
 * Only RBAC v2 users on a tenant running V2 scoring are sent to the admin app,
 * and only until `maScoringLegacyMethods` is on. Everyone else gets the modal:
 * legacy (non-RBAC) users because of the RGI-1024 constraint in `utils/rbac.ts`
 * that they see zero behavioral change, and tenants without `maScoringModelsV2`
 * because MA won't render argo model scores for them anyway — sending them to
 * author one would produce a model they can't use.
 */
export const useScoringMethodModal = (): boolean => {
  const scoringV2Enabled = useFeatureFlag("maScoringModelsV2", false);
  const legacyMethodsEnabled = useFeatureFlag("maScoringLegacyMethods", false);
  return (
    !scoringV2Enabled || !isV2User(getUserClaims().rbac) || legacyMethodsEnabled
  );
};
